import React, { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  TextField,
  Button,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  IconButton,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import RefreshIcon from "@material-ui/icons/Refresh";

const useStyles = makeStyles((theme) => ({
  filterCard: {
    marginBottom: theme.spacing(2),
    backgroundColor: "#fafafa",
    borderRadius: "8px",
  },
  filterContent: {
    padding: theme.spacing(2),
  },
  filterGrid: {
    alignItems: "flex-end",
  },
  button: {
    marginTop: theme.spacing(0.5),
  },
  refreshButton: {
    marginLeft: theme.spacing(1),
  },
  formControl: {
    width: "100%",
  },
}));

interface FilterPanelProps {
  filters: {
    startDate?: string;
    endDate?: string;
    groupBy?: "day" | "week" | "month";
  };
  onFilterChange: (filters: any) => void;
  onRefresh?: () => void;
}

const FilterPanel: React.FC<FilterPanelProps> = ({
  filters,
  onFilterChange,
  onRefresh,
}) => {
  const classes = useStyles();
  const [localFilters, setLocalFilters] = useState({
    startDate: filters?.startDate || "",
    endDate: filters?.endDate || "",
    groupBy: filters?.groupBy || "day",
  });

  const handleChange = (field: string, value: any) => {
    const updated = { ...localFilters, [field]: value };
    setLocalFilters(updated);
  };

  const handleApplyFilters = () => {
    onFilterChange(localFilters);
  };

  const handleLast7Days = () => {
    const endDate = new Date();
    const startDate = new Date();
    startDate.setDate(startDate.getDate() - 7);

    const start = startDate.toISOString().split("T")[0];
    const end = endDate.toISOString().split("T")[0];

    const updated = {
      ...localFilters,
      startDate: start,
      endDate: end,
    };
    setLocalFilters(updated);
    onFilterChange(updated);
  };

  const handleLast30Days = () => {
    const endDate = new Date();
    const startDate = new Date();
    startDate.setDate(startDate.getDate() - 30);

    const start = startDate.toISOString().split("T")[0];
    const end = endDate.toISOString().split("T")[0];

    const updated = {
      ...localFilters,
      startDate: start,
      endDate: end,
    };
    setLocalFilters(updated);
    onFilterChange(updated);
  };

  return (
    <Card className={classes.filterCard}>
      <CardContent className={classes.filterContent}>
        <Grid container spacing={2} className={classes.filterGrid}>
          {/* Data Inicial */}
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="Data Inicial"
              type="date"
              value={localFilters.startDate}
              onChange={(e) => handleChange("startDate", e.target.value)}
              InputLabelProps={{ shrink: true }}
              fullWidth
            />
          </Grid>

          {/* Data Final */}
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="Data Final"
              type="date"
              value={localFilters.endDate}
              onChange={(e) => handleChange("endDate", e.target.value)}
              InputLabelProps={{ shrink: true }}
              fullWidth
            />
          </Grid>

          {/* Agrupamento */}
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth>
              <InputLabel>Agrupar por</InputLabel>
              <Select
                value={localFilters.groupBy}
                onChange={(e) => handleChange("groupBy", e.target.value)}
              >
                <MenuItem value="day">Dia</MenuItem>
                <MenuItem value="week">Semana</MenuItem>
                <MenuItem value="month">Mês</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          {/* Botões de Ação */}
          <Grid item xs={12} sm={6} md={3}>
            <Box display="flex" style={{ gap: 8 }}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleApplyFilters}
                fullWidth
                className={classes.button}
              >
                Aplicar
              </Button>
              <IconButton
                onClick={onRefresh}
                size="small"
                className={classes.refreshButton}
                title="Atualizar dados"
              >
                <RefreshIcon />
              </IconButton>
            </Box>
          </Grid>
        </Grid>

        {/* Quick Filters */}
        <Box marginTop={2} display="flex" style={{ gap: 8 }}>
          <Button
            variant="outlined"
            size="small"
            onClick={handleLast7Days}
          >
            Últimos 7 dias
          </Button>
          <Button
            variant="outlined"
            size="small"
            onClick={handleLast30Days}
          >
            Últimos 30 dias
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};

export default FilterPanel;
